import React, { useEffect, useState } from 'react';
import { puntosApi, asList, cardStyle } from './puntosApi';

/** Configuración rápida: qué productos y promociones cuentan para el punto de cada compra. */
const ProductosPuntos = () => {
    const [products, setProducts] = useState([]);
    const [promos, setPromos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [savingId, setSavingId] = useState(null);

    useEffect(() => {
        Promise.all([puntosApi.products(), puntosApi.promotions()])
            .then(([p, c]) => {
                setProducts(asList(p.data));
                setPromos(asList(c.data));
            })
            .catch((err) => console.error('[Puntos] Error cargando productos', err))
            .finally(() => setLoading(false));
    }, []);

    const updateProduct = async (product, changes) => {
        const previous = products;
        setProducts((list) => list.map((p) => (p.id === product.id ? { ...p, ...changes } : p)));
        setSavingId(product.id);
        try {
            await puntosApi.patchProduct(product.id, changes);
        } catch (err) {
            console.error('[Puntos] Error guardando producto', err);
            setProducts(previous);
            alert(`No se pudo guardar "${product.name}".`);
        } finally {
            setSavingId(null);
        }
    };

    const updatePromo = async (promo, changes) => {
        const previous = promos;
        setPromos((list) => list.map((p) => (p.id === promo.id ? { ...p, ...changes } : p)));
        setSavingId(promo.id);
        try {
            await puntosApi.patchPromotion(promo.id, changes);
        } catch (err) {
            console.error('[Puntos] Error guardando promoción', err);
            setPromos(previous);
            alert(`No se pudo guardar "${promo.name}".`);
        } finally {
            setSavingId(null);
        }
    };

    if (loading) return <p>Cargando…</p>;

    const term = search.trim().toLowerCase();
    const filtered = products.filter((p) => !term || p.name.toLowerCase().includes(term));
    const earning = products.filter((p) => p.earns_points).length;

    return (
        <div style={{ display: 'grid', gap: '1.5rem' }}>
            <div style={cardStyle}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
                    <div>
                        <h3 style={{ margin: 0, color: 'var(--primary-color)' }}>Productos</h3>
                        <small style={{ color: '#6b7280' }}>{earning} de {products.length} dan puntos · cada compra que incluya al menos uno suma 1 punto</small>
                    </div>
                    <input className="form-control" style={{ maxWidth: 260 }} placeholder="Buscar producto…" value={search} onChange={(e) => setSearch(e.target.value)} />
                </div>
                <div style={{ overflowX: 'auto' }}>
                    <table className="table">
                        <thead>
                            <tr><th>Producto</th><th>Categoría</th><th>Da puntos</th></tr>
                        </thead>
                        <tbody>
                            {filtered.map((p) => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td>{p.category_name}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={!!p.earns_points}
                                            disabled={savingId === p.id}
                                            onChange={(e) => updateProduct(p, { earns_points: e.target.checked })}
                                            style={{ width: 20, height: 20, cursor: 'pointer' }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            <div style={cardStyle}>
                <h3 style={{ margin: 0, color: 'var(--primary-color)' }}>Promociones</h3>
                <small style={{ color: '#6b7280' }}>Si una promo no da puntos, sus productos no cuentan para el punto de la compra aunque el producto sí dé.</small>
                <div style={{ overflowX: 'auto', marginTop: '1rem' }}>
                    <table className="table">
                        <thead><tr><th>Promoción</th><th>Precio</th><th>Da puntos</th></tr></thead>
                        <tbody>
                            {promos.length === 0 && <tr><td colSpan="3">No hay promociones.</td></tr>}
                            {promos.map((c) => (
                                <tr key={c.id}>
                                    <td>{c.name}</td>
                                    <td>${c.price}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            checked={c.earns_points !== false}
                                            disabled={savingId === c.id}
                                            onChange={(e) => updatePromo(c, { earns_points: e.target.checked })}
                                            style={{ width: 20, height: 20, cursor: 'pointer' }}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default ProductosPuntos;
